import React from "react";
import { Modal, Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

function ViewUserWallets({ show, onHide, walletData }) {
    const { t } = useTranslation();
    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{t('user_wallets')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {walletData && walletData.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>{t('currency')}</th>
                                    <th>{t('address')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {walletData.map((wallet, index) => (
                                    <tr key={index}>
                                        <td>{wallet.wallet_type}</td>
                                        <td>{wallet.wallet_address}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p>{t('no_wallets_found')}</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ViewUserWallets;
